import {
  CalendarRequest,
  CalendarResponse,
} from '@api/api/financial-events/calendar';
import { financialEvents } from '@api/api/financial-events/financial-events';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_FINANCIAL_EVENTS_CALENDAR =
  'QUERY_KEY_FINANCIAL_EVENTS_CALENDAR';

export const useFinancialEventsCalendar = (body: CalendarRequest) =>
  useQuery({
    queryKey: [QUERY_KEY_FINANCIAL_EVENTS_CALENDAR, body],
    queryFn: ({ signal }) => {
      const { path, schema } = financialEvents.postCalendars;
      return wretchRequest<CalendarResponse>(path, {
        schema,
        body,
        method: 'post',
        signal,
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
  });
